import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

export interface HasPendingChanges {
  canDeactivate(): boolean;
}

@Injectable({ providedIn: 'root' })
export class PendingChangesGuard implements CanDeactivate<HasPendingChanges> {
  canDeactivate(component: HasPendingChanges): boolean {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
